import { PDFDownloadLink } from '@react-pdf/renderer';
import Anniversary from './Anniversary';

const AnniversaryQuotation = ({ pdfData }) => {
  const fileName = 'AnniversaryQuotation.pdf';
  return (
    <div className="download-link">
      <center>
        <PDFDownloadLink
          document={<Anniversary  pdfData={pdfData?.quotation_details} mob_no_status={pdfData?.mob_no_status}/>}
          fileName={fileName}
          style={{ textDecoration: 'none' }}
        >
          {({ loading }) => (
            <button className="btn btn-success text-white my-3">
              {loading ? 'Preparing document...' : 'Download Anniversary Quotation'}
            </button>
          )}
        </PDFDownloadLink>
      </center>
    </div>
  );
};

export default AnniversaryQuotation;